import {Pipe, PipeTransform} from "@angular/core";

/**
 * Pipe for rounding cost values with specific rules.
 *
 * @example <div>1233.446 | costRound"></div>
 */
@Pipe({
    name: 'costRound',
    standalone: false
})
export class CostRoundPipe implements PipeTransform  {

  /**
   * @inheritDoc
   * @param value The value that should be rounded
   * @param absolute optional, if the value should be returned as absolute value
   */
  transform(value: number, absolute: boolean = false): number {
    const abs = Math.abs(value);
    if(absolute === true) {
      value = Math.abs(value);
    }
    // if absolute = false we need to keep the value above/below 0
    const factor = value < 0? -1 : 1;

    if(abs <= 10) {
      return Math.floor(abs) * factor;
    }
    if(abs <= 100) {
      return Math.floor(abs / 10) * 10 * factor;
    }
    if(abs <= 1000) {
      return Math.floor(abs / 50) * 50 * factor;
    }

    return Math.floor(abs / 500) * 500 * factor;
  }
}
